import React from "react";

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_drink-food-expert/artifacts/dl9rwqw0_high-resolution-color-logo.png";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-brand-dark text-brand-cream py-20 border-t border-brand-border-dark"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-10 mb-16">
                    <div className="col-span-12 md:col-span-5">
                        <div className="flex items-center gap-3 mb-6">
                            <img
                                src={LOGO_URL}
                                alt="Eat + Drink Consulting"
                                width="56"
                                height="56"
                                loading="lazy"
                                decoding="async"
                                className="h-14 w-14 rounded-full"
                            />
                            <div>
                                <div className="font-serif text-2xl">
                                    Eat <span className="text-brand-orange">+</span> Drink
                                </div>
                                <div className="text-[10px] uppercase tracking-[0.3em] text-brand-cream/60">
                                    Consulting
                                </div>
                            </div>
                        </div>
                        <p className="text-brand-cream/70 leading-relaxed max-w-sm">
                            Strategic consulting for restaurants, bars, and hospitality
                            brands that want more revenue and more loyal customers.
                        </p>
                    </div>

                    <div className="col-span-6 md:col-span-3">
                        <h4 className="text-[10px] uppercase tracking-[0.3em] text-brand-orange mb-5">
                            Explore
                        </h4>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    href="#services"
                                    data-testid="footer-link-services"
                                    className="hover:text-brand-orange transition-colors"
                                >
                                    Services
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#packages"
                                    data-testid="footer-link-packages"
                                    className="hover:text-brand-orange transition-colors"
                                >
                                    Packages
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#process"
                                    data-testid="footer-link-process"
                                    className="hover:text-brand-orange transition-colors"
                                >
                                    Process
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#about"
                                    data-testid="footer-link-about"
                                    className="hover:text-brand-orange transition-colors"
                                >
                                    About Amy
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#faq"
                                    data-testid="footer-link-faq"
                                    className="hover:text-brand-orange transition-colors"
                                >
                                    FAQ
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="col-span-6 md:col-span-4">
                        <h4 className="text-[10px] uppercase tracking-[0.3em] text-brand-orange mb-5">
                            Contact
                        </h4>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    href="mailto:hello@eatdrinkconsulting.com"
                                    data-testid="footer-email"
                                    className="hover:text-brand-orange transition-colors"
                                >
                                    hello@eatdrinkconsulting.com
                                </a>
                            </li>
                            <li>
                                <a
                                    href="tel:+13232125323"
                                    data-testid="footer-phone"
                                    className="hover:text-brand-orange transition-colors"
                                >
                                    323-212-5323
                                </a>
                            </li>
                            <li className="text-brand-cream/60">
                                Remote consulting · worldwide
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Big logotype */}
                <div className="border-t border-brand-border-dark pt-12">
                    <h2 className="font-serif text-[14vw] md:text-[10vw] leading-[0.85] tracking-tighter text-brand-cream/95">
                        Eat <span className="text-brand-orange italic">+</span> Drink.
                    </h2>
                </div>

                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mt-10 pt-6 border-t border-brand-border-dark text-xs uppercase tracking-[0.2em] text-brand-cream/50 gap-4">
                    <div>© {new Date().getFullYear()} Eat + Drink Consulting. All rights reserved.</div>
                    <div className="italic font-serif normal-case tracking-normal text-brand-cream/70">
                        Drive more revenue. Get more customers.
                    </div>
                </div>
            </div>
        </footer>
    );
}
